import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import type * as fhirTypes from "fhir/r4";

interface AddCareMemberParams {
  practitionerId?: string;
}

interface AddCareMemberResponse {
  careteam: fhirTypes.CareTeam;
}

export const useAddCareMember = (patientId: string) => {
  const queryClient = useQueryClient();

  return useApiMutation<AddCareMemberResponse, AddCareMemberParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chat.CareTeam.ADD_MEMBER(patientId),
      mutationFn: (params) => {
        return axiosInstance.post(
          `/clinic/careteam/patient/${patientId}/add-member`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chat.CareTeam.DEFAULT(patientId),
        });
      },
    },
  });
};
